import * as React from "react";
const SvgRecommended = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 16 15", ...props }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m8 0 1.8 5.53h5.8l-4.7 3.41 1.8 5.53L8 11.06l-4.7 3.41 1.8-5.53L.4 5.53h5.8z" }));
export default SvgRecommended;
